import ResearchGroupInfo from './ResearchGroupInfo';
import ResearchGroupHome from './ResearchGroupHome';
import './ResearchGroupPage.css';
import './SideMenu.css';
import { useLocation, useParams, NavLink } from 'react-router-dom';
import { useState } from 'react';
import { groups, clusters } from './groups';
import ResearchGroupSearchResult from './ResearchGroupSearchResults';
import SearchPanel from './SearchPanel';

export default function ResearchGroupPage() {

    const [ openCluster, setOpenCluster ] = useState("");
    const { groupId } = useParams();
    const location = useLocation();
    const param = new URLSearchParams(location.search);
    const lang = param.get("lang") === "en" ? "en" : "hu";
    const group = groups.find(d => groupId === d.id);

    return (
        <div id="research-group-main" className="page-main">
            <div className="side-panel">
                {group && <div className="search-panel-container"><SearchPanel lang={lang}/></div>}
                <NavLink to={() => {
                    const param = new URLSearchParams(location.search);
                    param.delete("search");
                    return `/groups?${param.toString()}`;
                }} activeClassName="side-panel-menu-item-active" className="side-panel-menu-item" isActive={() => !group && groupId!=="search"}>
                    <h3>{lang === "hu" ? "Kutatási területek:" : "Research fields:"}</h3>
                </NavLink>
                <ul className="side-panel-menu-items">
                    {clusters.map((d, ix) => 
                        <li className={`side-panel-menu-item${openCluster === d.id ? " side-panel-menu-item-active" : ""}`}
                            key={ix}
                            onClick={e => setOpenCluster(d.id)}
                        >
                        {d[lang]}
                        {openCluster === d.id  && (<div className="group-items">
                            {groups.filter(g => g.cluster.includes(d.id)).map((e, ix) => (
                                <NavLink to={() => {
                                    const param = new URLSearchParams(location.search);
                                    param.delete("search");
                                    return `/groups/${e.id}?${param.toString()}`;
                                }} activeClassName="group-item-active" className="group-item" key={ix} isActive={() => group && (group.id === e.id)}>
                                    {e[lang]}
                                </NavLink>))}
                            </div>)}
                        </li>)}
                </ul>
            </div>
            <div className="content-panel">
                {group && <ResearchGroupInfo file={Object.keys(group.file).includes(lang) ? group.file[lang] : group.file["hu"]} lang={lang}/>}
                {!group && groupId!=="search" && <ResearchGroupHome lang={lang}/>}
                {!group && groupId==="search" && <ResearchGroupSearchResult lang={lang} search={param.get("search")}/>}
            </div>
        </div>        
    );
}
